import React, { useEffect, useRef, useState } from "react";
import "./SideCardHorizntalTabComp.css";
import * as FeatherIcon from "react-feather";
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../../../services/commonService";
import { useLocation, useParams } from "react-router-dom";

function SideCardHorizntalTabComp({ tabConfig, showMoreModal, setShowMoreModal,activeTab = 'tab1', setActiveTab, oppName}) {

  const {accountName } = useParams();
  var currentUrl = useLocation().pathname;
  var pageParsedData = getUrlDetailsObj(useLocation, useParams);
  const tabRefs = useRef({});
  const tabContainerRef = useRef(null); // Reference for tab container
  const ActiveComponent = tabConfig?.find(
    (tab) => tab?.key === activeTab
  )?.Component;
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [showArrows, setShowArrows] = useState(false); // New state to control arrow visibility

  const updateScrollButtons = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      const canScrollLeftValue = tabContainer.scrollLeft > 0;
      const canScrollRightValue =
        tabContainer.scrollLeft + tabContainer.clientWidth <
        tabContainer.scrollWidth;

      setCanScrollLeft(canScrollLeftValue);
      setCanScrollRight(canScrollRightValue);

      // Show arrows only if the content is scrollable
      setShowArrows(tabContainer.scrollWidth > tabContainer.clientWidth);
    }
  };

  const scrollLeft = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  useEffect(() => {
    updateScrollButtons(); // Initially check if scrolling is needed
    const tabContainer = tabContainerRef.current;

    if (tabContainer) {
      tabContainer.addEventListener("scroll", updateScrollButtons);
      window.addEventListener("resize", updateScrollButtons); // Recheck on window resize
    }

    return () => {
      if (tabContainer) {
        tabContainer.removeEventListener("scroll", updateScrollButtons);
      }
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, []);

  useEffect(() => {
    if (tabRefs.current[activeTab]) {
      tabRefs.current[activeTab].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeTab]);

  useEffect(() => {
    if(showMoreModal){
      
      // console.log("XXXXXXXXXXXXXXXXXXX : ", activeTab)

      var parentTabName = ""
      var activeTabName = tabConfig?.find(
        (tab) => tab?.key === activeTab
      )?.label
      switch(activeTab){
        case 'battle_card_so':
        case 'contact_map_so':
          parentTabName = "Spot Opportunities"
          break;

        case 'battle_card_wo':
        case 'contact_map_wo':
        case 'business_case_wo':
        case 'news_wo':
        case 'prompter_wo':
        case 'next_step_wo':
        case 'pitch_card_wo':
        case 'closure_note_wo':
          parentTabName = "Win Opportunities"
          break;

        case 'increase_deal_size':
        case 'battle_card_ids':
        case 'contact_map_ids':
        case 'business_case_ids':
        case 'news_ids':
        case 'prompter_ids':
        case 'next_step_ids':
          parentTabName = "Increase Deal Size"
          break;

        case 'battle_card_sc':
        case 'opportunity_map_sc':
        case 'reachout_sc':
          parentTabName = "Targeted Reach Out"
          break;

        case 'battle_card_nudge':
          parentTabName = "Nudges"
          break;
      }

      // console.log("titleForSideCard : ", titleForSideCard)

      let userStat1 = getUserStatsObject(
        parentTabName,
        activeTabName,
        "Data: "+ oppName,
        currentUrl
      );
      userStat1.url_details = pageParsedData;
      recordActivity(userStat1);

      // console.log("activeTabName : ", activeTabName)
    }
  }, [activeTab, showMoreModal])

  return (
    <div className="tab-wrapper">

        <>
          <div className="horizontal-tabs">
            {showArrows && (
              <>
                <button
                  className="scroll-btn left-arrow"
                  onClick={scrollLeft}
                  disabled={!canScrollLeft}
                >
                  <FeatherIcon.ArrowLeftCircle className="icons_table mr-1" />
                </button>
              </>
            )}

            <div className="d-flex custom_nav_tab" ref={tabContainerRef}>
              {tabConfig?.map(({ key, label, icon }) => (
                <button
                  key={key}
                  ref={(el) => (tabRefs.current[key] = el)} 
                  className={`tab-button ${activeTab === key ? "active" : ""}`}
                  onClick={() => setActiveTab(key)}
                >
                  {icon}
                  <span className="tab-label">{label}</span>
                </button>
              ))}
            </div>

            {showArrows && ( // Conditionally render arrows based on `showArrows` state
              <>
                <button
                  className="scroll-btn right-arrow"
                  onClick={scrollRight}
                  disabled={!canScrollRight}
                >
                  <FeatherIcon.ArrowRightCircle className="icons_table mr-1" />
                </button>
              </>
            )}
          </div>
          <div className="tab-content">
            {ActiveComponent && <ActiveComponent />}
          </div>
        </>
      
    </div>
  );
}

export default SideCardHorizntalTabComp;
